import {useEffect} from 'react'
import {useSearchParams, useParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetStoreManagerStoreTicketRecord = () => {
	const [searchParams] = useSearchParams()
	const page = searchParams.get('page')
	const search = searchParams.get('search')
	const ticketTypeIdx = searchParams.get('voucherType')
	const {idx} = useParams()
	const sortBy = searchParams.get('sortBy')
	const sortDirection = searchParams.get('sortDirection')

	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	const [userRole] = useRoleCookie()
	const rolePath = getApiRolePath(userRole)

	useEffect(() => {
		let url = `/${rolePath}/store/manager/${idx}/ticket/record?page=${page || 1}`
		if (search) url += `&search=${search}`
		if (ticketTypeIdx) url += `&ticketTypeIdx=${ticketTypeIdx}`
		if (sortBy) url += `&sortBy=${sortBy}`
		if (sortDirection) url += `&sortDirection=${sortDirection}`

		fetchRequest('GET', url)
	}, [page, search, ticketTypeIdx, sortBy, sortDirection])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 400:
				if (fetchResult?.data?.error_code === 'page')
					setAlert('페이지 번호를 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1)
					setAlert('매니저 데이터가 존재하지 않습니다.')
		}
	}, [fetchResult])

	return [fetchResult, isLoading]
}

export default useGetStoreManagerStoreTicketRecord
